import { useNavigate, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { canAccessWelcomeSpace } from 'modules/employees/lib/utils'
import NewTaskModal from 'modules/tasks/components/NewTaskModal'

const useNavigateToIndex = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return () => navigate(navigation.tasks.fullPath())
}

const NewPage = () => {
  const { employee } = useCurrentSession()
  const { currentUserId } = useOutletContext<{ currentUserId: number }>()
  const navigateToIndex = useNavigateToIndex()
  // If a user with welcome space access tries to access ´/tasks/new´
  // we are redirecting them to the index page.
  const redirect = canAccessWelcomeSpace(employee)

  return (
    <>
      {redirect && navigateToIndex()}
      {!redirect && <NewTaskModal currentUserId={currentUserId} onClose={navigateToIndex} />}
    </>
  )
}

export default NewPage
